import React from 'react';

import { H4 } from 'components/typography';

import { useLabels } from '../../i18n/useLabels';
import type { SectionsRailViewModel } from '../../viewmodels/createSectionsRailViewModel';
import { SectionsRailEntry } from './SectionsRailEntry';

import styles from './SectionsRail.scss';

type Props = {
  viewModel: SectionsRailViewModel;
};

export function SectionsRail({ viewModel }: Props) {
  const labels = useLabels();

  return (
    <div className={styles.column}>
      <nav className={styles.rail} aria-label={labels.sectionsRailLabel}>
        <H4>{labels.sectionsRailTitle}</H4>
        <ul className={styles.list}>
          {viewModel.entries.map(entry => (
            <SectionsRailEntry key={entry.id} viewModel={entry} />
          ))}
        </ul>
      </nav>
    </div>
  );
}
